<template>
  <div>
    <b-table
      ref="table-stock-counting-divergences"
      responsive
      show-empty
      striped
      class="mb-1 bordered"
      :empty-text="getEmptyTableMessage($tc('STOCK_COUNTING.NAME'), 'female', queryExecuted)"
      :fields="fields"
      :items="items"
    >
      <template #cell(action)="row">
        <e-grid-actions
          :show-update="false"
          :show-delete="false"
          :show-read-only="$can('Read', 'StockCounting')"
          @read-only="$emit('read-only', row.item)"
        />
      </template>

      <template #cell(divergentSkusPercent)="{ item }">
        <b-badge :variant="divergenceVariant(item)">
          {{ item.divergentSkusPercent | percentage(1) }}
        </b-badge>
      </template>

      <template #cell(skus)="{ item }">
        {{ item.divergentSkus }} / {{ item.countedSkus }}
      </template>
    </b-table>

    <b-row>
      <b-col cols="6">
        <e-pagination-summary
          :current-page="paging.currentPage"
          :per-page="paging.pageSize"
          :total="paging.rowCount"
          :total-on-page="paging.rowsInCurrentPage"
        />
      </b-col>
      <b-col cols="6">
        <b-pagination
          :value="paging.currentPage"
          align="right"
          :total-rows="paging.rowCount"
          :per-page="paging.pageSize"
          aria-controls="table-stock-counting-divergences"
          @change="$emit('page-change', $event)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol, BTable, BPagination, BBadge } from 'bootstrap-vue'
import { EPaginationSummary, EGridActions } from '@/views/components'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BPagination,
    BBadge,
    EPaginationSummary,
    EGridActions,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
    paging: {
      type: Object,
      required: true,
    },
    queryExecuted: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    fields() {
      return [
        {
          label: this.$t('Ações'),
          key: 'action',
          class: 'text-center',
          thStyle: { width: '80px' },
        },
        {
          label: this.$t('Id'),
          key: 'countingId',
          class: 'text-center',
          thStyle: { width: '80px' },
        },
        {
          label: this.$t('Data/Hora'),
          key: 'countingDate',
          class: 'text-center',
          thStyle: { width: '140px' },
          formatter: value => this.$options.filters.datetime(value),
        },
        {
          label: this.$t('Loja'),
          key: 'storeName',
          thStyle: { minWidth: '170px' },
        },
        {
          label: this.$t('Grupo'),
          key: 'groupName',
          thStyle: { minWidth: '110px' },
        },
        {
          label: this.$t('Marca'),
          key: 'brandName',
          thStyle: { minWidth: '110px' },
        },
        {
          label: this.$t('SKUs divergentes'),
          key: 'skus',
          class: 'text-center',
          thStyle: { width: '130px' },
        },
        {
          label: this.$t('% divergentes'),
          key: 'divergentSkusPercent',
          class: 'text-center',
          thStyle: { width: '120px' },
        },
        {
          label: this.$t('Limite'),
          key: 'deviationThresholdPercent',
          class: 'text-center',
          thStyle: { width: '90px' },
          // Os desvios já vêm em pontos percentuais (0 a 100), por isso o multiplicador 1.
          formatter: value => (value == null ? '-' : this.$options.filters.percentage(value, 2, 1)),
        },
        {
          label: this.$t('Maior desvio'),
          key: 'maxDeviationPercent',
          class: 'text-center',
          thStyle: { width: '120px' },
          formatter: value => (value == null ? '-' : this.$options.filters.percentage(value, 2, 1)),
        },
        {
          label: this.$t('Desvio médio'),
          key: 'avgDeviationPercent',
          class: 'text-center',
          thStyle: { width: '120px' },
          formatter: value => (value == null ? '-' : this.$options.filters.percentage(value, 2, 1)),
        },
        {
          label: this.$t('Sobra'),
          key: 'positiveDifference',
          class: 'text-center',
          thStyle: { width: '100px' },
          formatter: value => this.$options.filters.number(value || 0, 3),
        },
        {
          label: this.$t('Falta'),
          key: 'negativeDifference',
          class: 'text-center',
          thStyle: { width: '100px' },
          formatter: value => this.$options.filters.number(value || 0, 3),
        },
        {
          label: this.$t('Finalizado por'),
          key: 'completedBy',
          formatter: value => value || '-',
          thStyle: { minWidth: '140px' },
        },
      ]
    },
  },

  methods: {
    /** Acima do limite quando a contagem tem ao menos um SKU divergente;
     * a intensidade acompanha a proporção de itens fora do limite. */
    divergenceVariant(item) {
      if (!item.hasDivergence) return 'success'
      if (item.divergentSkusPercent >= 0.1) return 'danger'
      return 'warning'
    },
  },
}
</script>

<style lang="scss" scoped></style>
